import { render, staticRenderFns } from "./ScreensTable.vue?vue&type=template&id=9b1118c0"
import script from "./ScreensTable.vue?vue&type=script&lang=js"
export * from "./ScreensTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports